import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import './index.css';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailPage from './pages/ProgramDetailPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import GalleryPage from './pages/GalleryPage';
import GrantsPage from './pages/GrantsPage';
import VolunteerPage from './pages/VolunteerPage';
import PartnerPage from './pages/PartnerPage';
import DonatePage from './pages/DonatePage';
import ContactPage from './pages/ContactPage';

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLayout from './components/admin/AdminLayout';
import AdminDonations from './pages/admin/AdminDonations';
import AdminVolunteers from './pages/admin/AdminVolunteers';
import AdminPartners from './pages/admin/AdminPartners';
import AdminPrograms from './pages/admin/AdminPrograms';
import AdminBlog from './pages/admin/AdminBlog';
import AdminGallery from './pages/admin/AdminGallery';
import AdminGrants from './pages/admin/AdminGrants';
import AdminContacts from './pages/admin/AdminContacts';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import AdminUsers from './pages/admin/AdminUsers';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminSettings from './pages/admin/AdminSettings';
import ScrollToTop from './components/ScrollToTop';
import AdminProgramCategories from './pages/admin/AdminProgramCategories';
import InsightsPage from './pages/InsightsPage';
import ImpactPage from './pages/ImpactPage';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminAbout         from './pages/admin/AdminAbout';

const ProtectedRoute = ({ children }) => {
  const { isAuth } = useAuth();
  return isAuth ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:id" element={<ProgramDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/grants" element={<GrantsPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/insights"   element={<InsightsPage />} />
            <Route path="/impact"     element={<ImpactPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="donations" element={<AdminDonations />} />
              <Route path="volunteers" element={<AdminVolunteers />} />
              <Route path="partners" element={<AdminPartners />} />
              <Route path="programs" element={<AdminPrograms />} />
              <Route path="program-categories" element={<AdminProgramCategories />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="grants" element={<AdminGrants />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="analytics"     element={<AdminAnalytics />} />
               <Route path="about"         element={<AdminAbout />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </SettingsProvider>
    </AuthProvider>
  );
}
export default App;
